import api from './api';
import {
  ProfileResponse,
  ProfileUpdateRequest,
  PasswordChangeRequest,
  SubscriptionResponse,
  SubscriptionPackage,
  SubscriptionSubscribeRequest,
  SubscriptionPaymentResponse,
} from '../types';

export const profileService = {
  async getProfile(): Promise<ProfileResponse> {
    const response = await api.get<ProfileResponse>('/profile');
    return response.data;
  },

  async updateProfile(data: ProfileUpdateRequest): Promise<ProfileResponse['user']> {
    const response = await api.patch<ProfileResponse['user']>('/profile', data);
    return response.data;
  },

  async changePassword(data: PasswordChangeRequest): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/profile/change-password', data);
    return response.data;
  },

  async getSubscription(): Promise<SubscriptionResponse> {
    const response = await api.get<SubscriptionResponse>('/profile/subscription');
    return response.data;
  },

  async subscribeToPackage(data: SubscriptionSubscribeRequest): Promise<SubscriptionResponse> {
    const response = await api.post<SubscriptionResponse>('/profile/subscription/subscribe', data);
    return response.data;
  },

  async cancelSubscription(): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/profile/subscription/cancel');
    return response.data;
  },

  async getSubscriptionPackages(): Promise<SubscriptionPackage[]> {
    const response = await api.get<SubscriptionPackage[]>('/profile/subscription/packages');
    return response.data;
  },

  async getPaymentHistory(limit: number = 10): Promise<SubscriptionPaymentResponse[]> {
    const response = await api.get<SubscriptionPaymentResponse[]>(
      `/profile/subscription/payments?limit=${limit}`
    );
    return response.data;
  },
};

